import { useSelector } from "react-redux";
import LoginButton from "./LoginButton";
import UserMenu from "./UserMenu";
import withAppProviders from "../withAppProviders";

const Auth = () => {
	const user = useSelector(({ auth }) => auth.user);
	return user.isUserLoaded ? <UserMenu /> : <LoginButton />;
};

export default withAppProviders(Auth)();
